import { combineReducers } from 'redux';

import createEditOrder from './createEditOrder/reducer';
import manageProcessOrder from './manageProcessOrder/reducer';
import processOrder from './processOrder/reducer';
import consolidate from './consolidate/reducer';

export default combineReducers({
  createEditOrder,
  manageProcessOrder,
  processOrder,
  consolidate,
});



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/reducer.js